// src/pages/WishlistPage.js
import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { LanguageContext } from "../context/LanguageContext";
import { getProductBySlug } from "../services/products.api";
import AddToCartSelectorDrawer from "../components/AddToCartSelectorDrawer";
import AddedToBagToast from "../components/AddedToBagToast";
import { getMyWishlist } from "../services/wishlist.api";

function WishlistPage() {
  const { wishlist, toggleWishlist, addToCart } = useCart();
  const { lang } = useContext(LanguageContext);
  const navigate = useNavigate();

  const [selectorOpen, setSelectorOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);

  const TEXT = {
    EN: {
      title: "YOUR WISHLIST",
      empty: "Your wishlist is empty.",
      addToCart: "Add to Cart",
      remove: "Remove",
      startShopping: "Start Shopping",
    },
    AR: {
      title: "المفضلة",
      empty: "قائمة المفضلة فارغة.",
      addToCart: "أضيفي إلى السلة",
      remove: "إزالة",
      startShopping: "ابدئي التسوق",
    },
  };

  const t = TEXT[lang];

  const handleAddToCartClick = async (item) => {
  if (!item.slug) {
    console.error("Wishlist item missing slug:", item);
    return;
  }

  try {
    const fullProduct = await getProductBySlug(item.slug);

    setSelectedProduct(fullProduct);
    setSelectedSize(null);
    setSelectedColor(null);
    setSelectorOpen(true);
  } catch (err) {
    console.error("Failed to load product for cart", err);
  }
};



  return (
    <>
      <AddedToBagToast />

      <div
  className="w-full min-h-screen bg-[#0F1A12] pt-[95px] px-4 pb-24 text-white"
  dir={lang === "AR" ? "rtl" : "ltr"}
>
  {/* BACK */}
  <button
    onClick={() => navigate(-1)}
    className="absolute top-[80px] left-4 text-3xl opacity-70 hover:opacity-100"
  >
    ×
  </button>

  {/* TITLE */}
  <h1 className="text-xl font-bold text-center tracking-widest">
    {t.title}
  </h1>
  <div className="h-[2px] w-16 bg-[#2E5A2A] mx-auto mt-2 mb-8" />

  {/* EMPTY STATE */}
  {wishlist.length === 0 && (
    <div className="flex flex-col items-center justify-center mt-24">
      <div className="w-20 h-20 border border-[#2E5A2A] rounded-full flex items-center justify-center">
        <img src="/icons/heart.png" className="w-9 opacity-60" alt="" />
      </div>

      <p className="text-[#9FB39C] text-sm mt-4">{t.empty}</p>

      <button
        onClick={() => navigate("/")}
        className="mt-6 px-6 py-3 bg-[#2E5A2A] rounded-md font-semibold text-sm hover:brightness-110"
      >
        {t.startShopping}
      </button>
    </div>
  )}

  {/* GRID */}
  {wishlist.length > 0 && (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-5xl mx-auto">
      {wishlist.map((item) => (
        <div
          key={item.id}
          className="
            border border-[#2E5A2A]
            rounded-lg
            bg-[#121F17]
            overflow-hidden
            transition
            hover:shadow-[0_0_20px_rgba(46,90,42,0.35)]
          "
        >
          <div className="bg-[#0F1A12]">
            <img
              src={item.image}
              alt={lang === "EN" ? item.nameEN : item.nameAR}
              className="w-full h-44 object-cover"
            />
          </div>

          <div className="p-3">
            <p className="text-sm font-semibold leading-tight">
              {lang === "EN" ? item.nameEN : item.nameAR}
            </p>

            <p className="font-bold mt-1 text-[#9FB39C]">
              ${item.price}
            </p>

            <div className="flex flex-col gap-2 mt-4">
              <button
                onClick={() => handleAddToCartClick(item)}
                className="
                  w-full py-2
                  bg-[#2E5A2A]
                  rounded-md
                  text-sm font-semibold
                  hover:brightness-110
                  transition
                "
              >
                {t.addToCart}
              </button>

              <button
                onClick={() => toggleWishlist(item)}
                className="
                  w-full py-2
                  border border-[#2E5A2A]
                  rounded-md
                  text-sm font-semibold
                  hover:bg-[#2E5A2A]/20
                  transition
                "
              >
                {t.remove}
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  )}
</div>


      {/* ADD TO CART SELECTOR */}
      <AddToCartSelectorDrawer
        isOpen={selectorOpen}
        onClose={() => setSelectorOpen(false)}
        product={selectedProduct}
        selectedSize={selectedSize}
        selectedColor={selectedColor}
        setSelectedSize={setSelectedSize}
        setSelectedColor={setSelectedColor}
      />
    </>
  );
}

export default WishlistPage;
